<template>
    <div class="d-flex flex-column gap-12 mb-6">
        <divcard>
            <div class="card">
                <div class="card-part pt-0 px-6 py-4">
                    <div class="d-flex justify-space-between">

                        <div class="txt-head black--text mb-2">
                            <span class="theme-color-one">ส่วนที่ 2 :</span> ไฟล์เเนบ
                        </div>
                        <Button theme="6" @onClick="addAttachment">
                            + เพิ่มไฟล์
                        </Button>
                    </div>
                    <div class="theme-color-seven mb-2">
                        *ไฟล์ที่ระบบรองรับ .PDF/.doc (สูงสุด 50 mb/ไฟล์)
                    </div>
                    <div class="">
                        <v-layout class="" v-for="(file, f) in attachment" :key="f">
                            <v-flex xs7>
                                <v-file-input v-model="files[f]" :id="'file' + f" :rules="rulesFile" color="#F15A29"
                                    style="border-radius: 30px" outlined :clearable="false" height="36" placeholder=""
                                    prepend-icon="" accept="application/pdf,.doc,.docx" v-show="checkValType(file.file_name) == 'object' ||
                                        file.file_name == '' ||
                                        file.file_name == null
                                        " @change="addToAttachment(files[f], f)"></v-file-input>
                                <v-text-field v-show="checkValType(file.file_name) == 'string'" v-model="file.file_name"
                                    outlined height="36" color="#F15A29" style="border-radius: 30px"
                                    readonly></v-text-field>
                            </v-flex>
                            <v-flex shrink ml-3>
                                <v-btn depressed dark rounded width="100" color="#464647" @click="selectFile(f)">
                                    <v-icon class="font-12 font-w-700" left>mdi-upload</v-icon>
                                    <span class="font-12 font-w-700">อัพโหลด</span>
                                </v-btn>
                            </v-flex>
                            <v-flex shrink ml-3>
                                <v-btn depressed height="35" width="35" fab dark color="#FD0C0C" @click="removeFile(f)">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </div>

                </div>
            </div>
        </divcard>
    </div>
</template>

<script>
import TextField from "../../../components/input/TextField"
import SwitchInset from "../../../components/input/SwitchInset"
import Button from "../../../components/input/Button"
import AutoBox from "../../../components/input/AutoBox"
import { eventBus, validateEmail } from "../../../plugins/global-funcs"
import { mapState } from "vuex"
import SelectBox from "../../../components/input/SelectBox";

export default {
    name: "Tccl1",
    components: {
        TextField,
        SelectBox,
        SwitchInset,
        Button,
        AutoBox
    },
    props: {
    },
    data() {
        return {
            form: {},
            files: [],
            attachment: [{}],
            rulesFile: [
                (value) => !!value || "กรุณาแนบเอกสาร",
                (value) => (!value || value.size <= 50000000) || "ขนาดไฟล์ต้องน้อยกว่า 50 MB!",
            ],
        }
    },
    computed: {
        ...mapState({
            GeneralForm: state => state.Tccl.GeneralForm,
        })
    },
    methods: {
    addAttachment() {
        this.attachment.push({})
        this.form = this.attachment
        console.log('addAttachment')
    },
    addToAttachment(file, i) {
        console.log('file size', file.size)
        //check if file size > 10mb then show dialog modal
        if (file.size > 50000000) {
            this.$store.commit('General/setModal', {
                title: 'ขนาดไฟล์เกิน 50 MB',
                theme: 'warning',
                text: 'กรุณาแนบไฟล์ที่มีขนาดไม่เกิน 50 MB',
                showCancel: false,
                buttonText: 'ตกลง'
            })
            //remove file in to last index of attachment
            this.attachment.pop()
            this.files.pop()
            return
        }
        this.attachment[i] = file
    },
    setData() {
        this.attachment = []
    },
    removeFile(id) {
        this.attachment.splice(id, 1);
        this.files.splice(id, 1);
        this.form = this.attachment
        console.log('removeFile', this.form)
    },
    selectFile(id) {
        // querySelector id file จากนั้นเรียก event click
        document.querySelector("#file" + id).click();
    },
    checkValType(val) {
      return typeof val;
    },
    },
  
}
</script>

<style lang="scss" scoped>
.tccl-form-flex {
    display: flex;
    flex-wrap: wrap;
    gap: 0px 2%;
}

.form-item {
    display: flex;
    flex-direction: column;
}

.flex-3 {
    flex: 0 0 32%;
}

.flex-2 {
    flex: 0 0 49%;
}

.flex-1 {
    flex: 0 0 100%;
}
</style>